<template>
	<div>
		<div>
			<table>
				<thead>
					<tr>
						<td>
							<div v-if="report?.header_image">
								<img ref="header" :src="apiOrigin+'/images/center/'+report?.header_image" alt="" style="display: block; width: 100%; max-height: 155px;">
							</div>
							<div v-if="report">
								<div class="ptable">
									<table>
										<tbody>
											<tr>
												<td><i class="far fa-user"></i> Patient Name</td>
												<td>
													<i class="fas fa-solid fa-play"></i>
													{{ report.patient_name }}
												</td>
												<td><i class="fa fa-file-invoice"></i> Reg No</td>
												<td>
													<i class="fas fa-solid fa-play"></i>
													{{ report.reg_no }}
												</td>
											</tr>
											<tr>
												<td>
													<i class="fas fa-arrows-rotate"></i>
													Refer By
												</td>
												<td>
													<i class="fas fa-solid fa-play"></i>
													{{ report.ref_doctor_name }}
												</td>
												<td>
													<i class="fas fa-venus-mars"></i>
													Age/Gender
												</td>
												<td>
													<i class="fas fa-solid fa-play"></i>
													{{ report.patient_age }} / <span style="text-transform: capitalize;">{{ report.patient_gender }}</span>
												</td>
											</tr>
											<tr>
												<td>
													<i class="fa fa-flask"></i>
													Department
												</td>
												<td>
													<i class="fas fa-solid fa-play"></i>
													{{department}}
												</td>
												<td>
													<i class="fa fa-clock-o"></i>
													Date
												</td>
												<td>
													<i class="fas fa-solid fa-play"></i>
													{{ format(report.test_date, "DD/MM/YY") }}
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</td>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							<div v-if="report">
								<div class="department">
									<span>{{ report.test.name }} Report</span>
								</div>

								<div style="padding: 20px;">
									<div v-if="report.impression" style="margin-bottom: 10px; text-transform: uppercase;">
										<b>Findings:</b>
									</div>
									<div v-html="report.report" style="padding-left: 20px;"></div>
									<div v-if="report.impression" style="margin-bottom: 10px; text-transform: uppercase;">
										<b>Impression:</b>
									</div>
									<div v-if="report.impression" v-html="report.impression"  style="padding-left: 20px;"></div>
									<div v-if="report.advice" style="margin-bottom: 10px; text-transform: uppercase;">
										<b>Advice:</b>
									</div>
									<div v-if="report.advice" v-html="report.advice"  style="padding-left: 20px;"></div>
									<b style="text-transform: uppercase;">Issued By:</b>
									<div class="clearfix" style="padding-left: 20px;">
										<div class="pull-left">
											<img ref="signature"
												:src="apiOrigin + '/images/radiologist_certificates/' + report?.radiologist?.signature_image" alt="">
										</div>
										<div class="pull-right" v-if="reportLink" style="position: relative;">
											<div style="position: absolute; padding: 4px; border-radius: 100%; width: 30px; height: 30px; left: 50px; top: 50px; border: 1px solid silver; background: #fff;">
												<img ref="qricon" src="/logo-icon.png" alt="" style="display: block; width: 100%; height: 100%">
											</div>
											<qrcode-vue :value="reportLink" :size="130"></qrcode-vue>
										</div>
									</div>
									<div v-if="report?.showDisclaimer" style="font-size: 10px; margin-top:8px">
										<b>Disclaimer:</b> It is an online interpretation of medical imaging based on clinical data. All modern
										machines / procedures have their own limitation. If there is any clinical discrepancy, this investigation
										may be repeated or reassessed by other tests. Patient's identification in online reporting is not
										established, so in no way this report can utilized for any medico legal purpose.
									</div>
								</div>

								<div v-if="images.length" style="page-break-before: always;">
									<div v-for="image in images" :key="image" style="text-align: center;">
										<img :src="apiOrigin + '/images/radiology/' + image" alt="" :id="image" style="display: inline-block;  border: 3px solid #000; border-radius: 8px; max-width: 100%; max-height: 700px; margin: auto; margin-bottom: 20px; margin-top: 20px; page-break-inside: avoid; break-inside: avoid;">
									</div>
								</div>

							</div>
						</td>
					</tr>
				</tbody>
				<tfoot>
					<tr>
						<td>
							<div v-if="report?.footer_image" style="visibility: hidden;">
								<img ref="footer" :src="apiOrigin+'/images/center/'+report?.footer_image" alt="" style="display: block; width: 100%;">
							</div>
						</td>
					</tr>
				</tfoot>
			</table>
			<div v-if="report?.footer_image" style="position: fixed; bottom: 0; left: 0; width: 100%;" class="only-print">
				<img ref="footer" :src="apiOrigin+'/images/center/'+report?.footer_image" alt="" style="display: block; width: 100%;">
			</div>
		</div>
	</div>
</template>
<script>
/* eslint-disable no-useless-escape */

import QrcodeVue from 'qrcode.vue'

export default {
	components: {
		QrcodeVue
	},
	data() {
		return {
			report: null,
			department: '',
			apiOrigin: window.apiOrigin,
			reportLink: '',
			open: !localStorage.center_access_token,
			images: []
		}
	},
	async mounted() {
		window.__xrayReportReady = false;
		window.__xrayReportError = "";

		let data = atob(this.$route.query.data).split(",");

		this.report = await this.post("fetch-xray-report-data", {
			center_id: data[0],
			id: data[1],
			open: this.open,
		});

		let report = this.report;
		if (!report || report.success === false) {
			window.__xrayReportError = "Failed to load X-Ray report data.";
			return;
		}

		this.department = 'X-Ray';
		if(['ct_head','ct_body','ct_abdomen','ct_cardiac','ct_special','ct_others'].includes(report?.test?.category)) this.department = 'Computed Tomography';

		if(this.$route.query.image && this.$route.query.image != 'false'){
			this.images = report.images ? report.images.split(",") : [];
			if(this.images.length && this.images[0].endsWith('.dcm')) this.images = [];
		}

		this.reportLink = report.showQRCode ? window.apiOrigin + '/print-xray-report?data=' + this.$route.query.data + '&image=true' : '';
		

		if(report?.header_image || report?.footer_image){
			window['pageStyle'].innerHTML = `@page {
				margin: 0px;
			}`;
		}else{
			let marginTop = report['report_margin_top'];
			let marginRight = report['report_margin_right'];
			let marginBottom = report['report_margin_bottom'];
			let marginLeft = report['report_margin_left'];
			this.pageStyle = `@page {
				margin: `+marginTop+`px `+marginRight+`px `+marginBottom+`px `+marginLeft+`px;
			}`;
			window['pageStyle'].innerHTML = this.pageStyle;
		}



		window.addEventListener('afterprint', this.afterPrint)

		let tryTimes = 0;
		let tryPrint = () => {
			let dsi = this.$refs.signature;
			let qricon = this.$refs.qricon;
			
			
			tryTimes++;
			if (tryTimes > 1000) return;

			let imagesLoaded = false;

			if(this.images.length){
				let hasIncomplete = false;
				for(let image of this.images){
					let el = document.getElementById(image);
					if(!el?.complete) hasIncomplete = true;
				}
				if(!hasIncomplete) imagesLoaded = true;
			}else{
				imagesLoaded = true;
			}

			


			if (imagesLoaded && (!this.report?.radiologist?.signature_image || (dsi?.complete)) && (!this.report.showQRCode || qricon?.complete) && (!this.report.header_image || this.$refs.header?.complete) && (!this.report.footer_image || this.$refs.footer?.complete)) {
				window.__xrayReportReady = true;
				window.print();
			} else {
				setTimeout(tryPrint.bind(this), 10);
			}
		}
		setTimeout(tryPrint.bind(this), 10);
	},
	methods: {
		print() {
			window.print()
		},
		mobileCheck() {
			let check = false;
			(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor);
			return check;
		},
		afterPrint() {
			window.removeEventListener('afterprint', this.afterPrint);

			let check = false;
			(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor);
			return false
			if(!check) this.$router.back();
		}
	}
}
</script>
<style scoped>
@media print {
	.print-hidden {
		display: none;
	}
}
@media screen {
	.only-print {
		display: none;
	}
}

.ptable {
	background-color: #eaf4ff;
	border: 1px solid #072f53;
	
	background: #eee;
	border: 1px solid #444;
	margin: 0 15px;

	border-radius: 8px;
	font-size: 15px;
	/* padding-bottom: 3px; */
	padding: 15px 30px;
	margin-top: 10px;

	font-family: Montserrat;

}
.ptable table {
	margin-bottom: 0;
}

.ptable table tr td {
	padding: 4px 0;
}


.ptable td, .ptable th {
	border: none;
	padding: 4px 0;
}
.ptable i {
	width: 18px;
   margin-right: 8px;
}

.ptable tr td:nth-child(2n) {
	font-weight: bold;
}

.ptable tr td .fa-play {
	font-size: 12px;
	color: #6394d2;
	color: #8d8d8d;
}

.department {
	text-align: center;
	height: 65px;
}
.department span {
	padding: 12px 20px;
	background: #bbb;
	font-weight: bold;
	font-size: 20px;
	border-radius: 8px;
}

</style>
